<style lang="scss">
.tabs {
  display: flex;
  margin-top: 20px;
  button {
    padding: 23px 10px !important;
  }

  .active {
    background-color: $c-blue !important;
    color: $c-white !important;
    border-color: $c-blue !important;
  }
}
</style>

<template>
  <div id="index">
    <Headline h1="Skillübersicht" :h2="`von ${name}`" />

    <div class="tabs">
      <button @click="onTab('data')" :class="{ active: tab == 'data' }">Skillübersicht</button>
      <button @click="onTab('grading')" :class="{ active: tab == 'grading' }">Mitarbeiter:innengespräch</button>
    </div>

    <IndexTables type="personal" :unit="id" :name="name" simple v-if="tab == 'data'" />
    <GradingForm :onSave="onSave" edit :userid="id" v-if="tab == 'grading'" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import IndexTables from '../../components/IndexTables.vue';
import GradingForm from './management/_GradingForm.vue';

export default defineComponent({
  components: {
    IndexTables,
    GradingForm,
  },
  setup() {
    const tab = ref<'data' | 'grading'>('data');
    const store = useStore();
    const router = useRouter();
    const name = ref('');

    const id = computed(() => parseInt(router.currentRoute.value.params.id.toString()));
    store.dispatch('fetchUserData', id.value).then((res: any) => {
      name.value = `${res.firstname} ${res.lastname}`;
    });

    const onTab = (val: 'data' | 'grading') => {
      tab.value = val;
    };

    const saving = ref(false);

    const onSave = (user: any) => {
      if (!saving.value) {
        saving.value = true;
        store.dispatch('updateWorker', { id: id.value, user }).then((res: any) => {
          store.dispatch('addNotification', { message: 'Mitarbeiter gespeichert' });
          saving.value = false;
          //router.push({ name: 'SkillsMitarbeiterList' });
        });
      }
    };

    return {
      id,
      name,
      tab,
      onTab,
      onSave,
    };
  },
});
</script>
